export default __webpack_public_path__ + "static/media/change-numeric-field-light.5f32385f.svg";